/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Showwrapuptime3Inputs */

const en_entity_showwrapuptime3 = /** @type {(inputs: Entity_Showwrapuptime3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Wrap-Up Time`)
};

const de_entity_showwrapuptime3 = /** @type {(inputs: Entity_Showwrapuptime3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachbearbeitungszeit anzeigen`)
};

/**
* | output |
* | --- |
* | "Show Wrap-Up Time" |
*
* @param {Entity_Showwrapuptime3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_showwrapuptime3 = /** @type {((inputs?: Entity_Showwrapuptime3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Showwrapuptime3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_showwrapuptime3(inputs)
	return de_entity_showwrapuptime3(inputs)
});
export { entity_showwrapuptime3 as "entity_showWrapUpTime" }